import { render } from "./GPCRExperiences.vue?vue&type=template&id=abe3a37e&scoped=true"
import script from "./GPCRExperiences.vue?vue&type=script&lang=js"
export * from "./GPCRExperiences.vue?vue&type=script&lang=js"

import "./GPCRExperiences.vue?vue&type=style&index=0&id=abe3a37e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abe3a37e"]])

export default __exports__